import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['Noches sin dormir pensando qué decirle mañana para que no se cierre más', 'Caminando sobre cáscaras de huevo para no generar otra explosión', 'Siempre los mismos sermones porque no sabés qué más intentar', 'La ansiedad, el encierro, la baja autoestima sin saber por dónde empezar', 'Grupos de WhatsApp de padres donde nadie tiene la solución real', 'Fin de semana agotado, el lunes el ciclo vuelve a empezar igual'];
  return <section className="py-24 relative overflow-hidden" data-id="element-172">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-173">
        <FadeIn data-id="element-174">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-8" data-id="element-175">
            ¿Cuántas noches más vas a quedarte{' '}
            <span className="text-red-500" data-id="element-176">sin dormir pensando qué hacer?</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-177">
          <p className="text-lg md:text-xl text-gray-300 text-center mb-12 leading-relaxed" data-id="element-178">
            Sos un padre o una madre que ama profundamente a su hijo/a. Pero
            nadie te dijo que la adolescencia iba a sentirse tan parecida a
            perderlo/a.
            <br data-id="element-179" />
            <br data-id="element-180" />
            <strong className="text-white" data-id="element-181">
              No es falta de amor. Es falta de herramientas.
            </strong>
          </p>
        </FadeIn>

        <div className="bg-surface p-8 md:p-10 rounded-3xl border border-red-500/20 shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-182">
          <ul className="space-y-6" data-id="element-183">
            {points.map((point, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-184">
                <li className="flex items-start gap-4" data-id="element-185">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-186" />
                  <span className="text-lg text-gray-300" data-id="element-187">{point}</span>
                </li>
              </FadeIn>)}
          </ul>
        </div>

        <FadeIn delay={0.8} data-id="element-188">
          <div className="mt-16 text-center" data-id="element-189">
            <p className="text-2xl md:text-3xl font-heading text-gold" data-id="element-190">
              ¿Y si esta fuera la última noche que pasás sin saber qué hacer?
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}